module.exports = __webpack_public_path__ + "img/yinhang.e247a213.svg";